import styled from 'styled-components';

export const UL = styled.ul`
    counter-reset: number;
    list-style-type: none;
    padding:0;

    li {
        display: flex;        
        padding-bottom: 30px;

        &:last-child {
            padding-bottom: 0;
        }

        &::before {
            display: block;
            font-weight: 700;
            min-width: 28px;
            font-size: 40px;
            line-height: 48.86px;
            letter-spacing: 0.02em;
            color: #f2f2f2;
            margin-right: 21px;
            counter-increment: number;
            content: counter(number);
        }
    }
`;